<template>
  <div class="sidebar">
    <div class="sidebar-header">
      <h3>{{ menuTitle }}</h3>
    </div>
    <div class="sidebar-menu" v-if="menuCategories">
      <div 
        v-for="subcategory in menuCategories.children" 
        :key="subcategory.id"
        class="menu-category"
      >
        <!-- 二级菜单 -->
        <div 
          class="submenu-item"
          :class="{ active: selectedCategoryId === subcategory.id }"
          @click="handleMenuClick(subcategory)"
        >
          <span>{{ subcategory.name }}</span>
          <i 
            v-if="showArrowFor(subcategory)"
            class="arrow-icon" 
            :class="{ expanded: expandedSubcategoryId === subcategory.id }"
          >
            >
          </i>
        </div>
        
        <!-- 三级菜单 -->
        <div 
          v-if="expandedSubcategoryId === subcategory.id && subcategory.children && !isFromContents(subcategory)" 
          class="third-level-menu"
        >
          <div 
            v-for="thirdLevel in subcategory.children" 
            :key="thirdLevel.id"
            class="third-level-item"
            :class="{ active: selectedCategoryId === thirdLevel.id }"
            @click="handleMenuClick(thirdLevel)"
          >
            {{ thirdLevel.name }}
          </div>
        </div>
      </div>
    </div>
    <div v-else class="sidebar-loading">
      <p>加载中...</p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SidebarNavigation',
  props: {
    menuTitle: {
      type: String,
      required: true
    },
    menuCategories: {
      type: Object,
      default: () => {}
    },
    selectedCategoryId: {
      type: [Number, String],
      default: null
    },
    expandedSubcategoryId: {
      type: [Number, String],
      default: null
    }
  },
  methods: {
    handleMenuClick(item) {
      this.$emit('menu-click', item);
    },
    // 判断是否为从 contents 转换来的节点
    isFromContents(node) {
      return !!(node && node._fromContents)
    },
    // 是否显示二级菜单右侧箭头
    showArrowFor(subcategory) {
      if (!subcategory) return false
      if (this.isFromContents(subcategory)) return false
      const hasChildren = Array.isArray(subcategory.children) && subcategory.children.length > 0
      return hasChildren
    }
  }
}
</script>

<style lang="scss" scoped>
// 左侧导航
.sidebar {
  width: 15rem;
  height: 40rem;
  background: white;
  border-radius: 8px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  
  .sidebar-header {
    background: #5e7c85;
    color: white;
    padding: 15px;
    border-radius: 8px 8px 0 0;
    
    h3 {
      margin: 0;
      font-size: 18px;
      font-weight: 600;
    }
  }
  
  .sidebar-menu {
    padding: 0;
    
    .menu-category {
      border-bottom: 1px solid #f0f0f0;
      
      &:last-child {
        border-bottom: none;
      }
    }
    
    .submenu-item {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 12px 15px;
      cursor: pointer;
      transition: all 0.3s ease;
      border-left: 3px solid transparent;
      background: white;
      
      &:hover {
        background: #f8f9fa;
        border-left-color: #5e7c85;
      }
      
      &.active {
        background: #e3f2fd;
        color: #177cb0;
        font-weight: 600;
        border-left-color: #177cb0;
        box-shadow: inset 3px 0 0 #177cb0;
      }
      
      .arrow-icon {
        color: #177cb0;
        font-weight: bold;
        font-size: 16px;
        transition: transform 0.3s ease;
        
        &.expanded {
          transform: rotate(90deg);
        }
      }
    }
    
    .third-level-menu {
      background: #f8f9fa;
      
      .third-level-item {
        padding: 10px 15px 10px 35px;
        cursor: pointer;
        transition: all 0.3s ease;
        border-left: 3px solid transparent;
        font-size: 14px;
        
        &:hover {
          background: #e9ecef;
          border-left-color: #5e7c85;
        }
        
        &.active {
          background: #e3f2fd;
          color: #177cb0;
          font-weight: 600;
          border-left-color: #177cb0;
        }
      }
    }
  }
  
  .sidebar-loading {
    text-align: center;
    padding: 20px;
    color: #666;
  }
}

// 响应式设计
@media (max-width: 768px) {
  .sidebar {
    width: 100%;
    margin-bottom: 20px;
    max-width: 300px;
  }
}
</style>
